import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import fetchAdministratorPermissions from '../../actions/administratorPermissions/fetchAdministratorPermissions'
import setAdministratorPermissions from '../../actions/administratorPermissions/setAdministratorPermissions'
import awaitAccessToken from '../../modules/awaitAccessToken'

const onFetchAdministratorPermissions = function* onFetchAdministratorPermissions() {
  yield takeLatest(actionTypes.ADMINISTRATOR_PERMISSIONS.FETCH, function* onFetchAdministratorPermissionsSaga(action) {
    const accessToken = yield call(awaitAccessToken)

    let response

    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.administrators}/permissions`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
          'X-Infowijs-Client': 'nl.infowijs.admin',
        },
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reFetchPermissions() {
          yield put(fetchAdministratorPermissions())
        })
      }

      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    yield put(setAdministratorPermissions(response.data.data))

    acceptAction(action, response.data.data)
  })
}

export default onFetchAdministratorPermissions
